import type { EPGEntryDto } from "$src/core/models/dto";
import programTimeRangeMs from "$src/core/utils/epg/program-time-range-ms";

/** Whether `nowMs` falls inside this entry’s programme window (half-open [start, end)). */
const isEpgEntryLiveAt = (entry: EPGEntryDto, nowMs: number): boolean => {
  const range = programTimeRangeMs(entry);
  return range != null && nowMs >= range.start && nowMs < range.end;
};

export default isEpgEntryLiveAt;
